"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToggleSwitch = require("./ToggleSwitch");

var _ToggleSwitch2 = _interopRequireDefault(_ToggleSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ToggleSwitch2.default;